// Product Categories
// Each category has an id, name, description, and image
export const categories = [
  {
    id: 1,
    name: "Moisturizers",
    description: "Deep hydration for your natural hair",
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741946456/IMG_9533_vmkaby.jpg",
  },
  {
    id: 2,
    name: "Oils",
    description: "Natural oils for hair growth and shine",
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741946292/IMG_9563_b7ttqx.jpg",
  },
  {
    id: 3,
    name: "Treatments",
    description: "Intensive care for damaged hair",
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741946492/Hair_Butter_etvhli.jpg",
  },
  {
    id: 4,
    name: "Bundles",
    description: "Value packs for complete hair care",
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741946157/IMG_9603_q20ujf.jpg",
  },
  {
    id: 5,
    name: "Accessories",
    description:
      "Essential hair care tools and accessories for your natural hair journey",
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1742824971/towel_5_ccjlae.jpg",
    featured: true,
  },
];

// Product Images Configuration
// Contains image sets for different product types
const productImages = {
  moisturizer: {
    main: "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741946456/IMG_9533_vmkaby.jpg",
    angle:
      "https://images.unsplash.com/photo-1608248543804-c3be81b85308?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    detail:
      "https://images.unsplash.com/photo-1608248543805-d97066b378e8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    usage:
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  },
  oil: {
    main: "https://images.unsplash.com/photo-1608248597279-f99d160bfcbc?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    angle:
      "https://images.unsplash.com/photo-1608248597280-f99d160bfcbd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    detail:
      "https://images.unsplash.com/photo-1608248597281-f99d160bfcbe?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    usage:
      "https://images.unsplash.com/photo-1522337660859-02fbefca4702?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  },
  treatment: {
    main: "https://images.unsplash.com/photo-1599751449128-eb7249c3d6b1?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    angle:
      "https://images.unsplash.com/photo-1599751449129-eb7249c3d6b2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    detail:
      "https://images.unsplash.com/photo-1599751449130-eb7249c3d6b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    usage:
      "https://images.unsplash.com/photo-1522338242992-e1a54906a8da?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  },
  accessories: {
    main: "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1742824951/towel_4_chicmd.jpg",
    angle:
      "https://images.unsplash.com/photo-1630082900894-edbd503588f7?q=80&w=1964&fm=jpg",
    detail:
      "https://images.unsplash.com/photo-1630082900894-edbd503588f7?q=80&w=1964&fm=jpg",
    usage:
      "https://images.unsplash.com/photo-1630082900894-edbd503588f7?q=80&w=1964&fm=jpg",
  },
};

// Main Products Array
// Products are organized by type: Individual Products (1-6) and Bundles (7-11)
export const products = [
  // === Individual Products ===
  // 1. Moisturizing Hair Cream
  {
    id: 1,
    name: "Moisture Lock",
    description: "Leave in conditioner for all hair types",
    price: 55.0,
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741946456/IMG_9533_vmkaby.jpg",
    category: "Moisturizers",
    featured: true,
    images: productImages.moisturizer,
    details: {
      usage:
        "Apply on damp hair, massage and style. Use to moisturize hair after wash and when needed. Do not rinse out.",
      benefits: [
        "Deep hydration for dry hair",
        "Reduces frizz and breakage",
        "Enhances natural curl pattern",
        "Promotes hair elasticity",
      ],
      ingredients:
        "Aqua, grapeseed oil, shea butter, rice bran oil, behentrimonium methosulfate, Cetearyl alcohol, cetyl alohol, D Panthenol, Sodium PCA, Oats extract, stearalkonium chloride, saw Palmetto, Hydrolized silk protein, Hydrolized collagen peptide, fragrance, Germall plus",
      whenToUse: [
        "After washing hair",
        "In between washes",
        "Before protective styling",
        "As a daily moisturizer",
      ],
      tips: "For best results, apply to slightly damp hair and seal with an oil of your choice.",
    },
  },

  // 2. Growth Oil Blend
  {
    id: 2,
    name: "Liquid Gold (Small)",
    description: "Natural oil blend for hair growth and scalp health",
    price: 60.0,
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741946266/IMG_9572_yg7syq.jpg",
    category: "Oils",
    featured: true,
    images: productImages.oil,
    details: {
      usage:
        "Massage into scalp and distribute through hair. Use 2-3 times per week.",
      benefits: [
        "Stimulates hair growth",
        "Nourishes scalp",
        "Strengthens hair follicles",
        "Prevents breakage",
      ],
      ingredients:
        "Castor Oil, Sunflower Oil, Fenugreek, Lavender Essential Oil, Amla Powder, Vitamin E",
      whenToUse: [
        "During scalp massages",
        "Before washing hair (pre-poo)",
        "Before bed for overnight treatment",
        "As a sealant after moisturizing",
      ],
      tips: "Warm the oil slightly before application for better absorption. Perfect for hot oil treatments.",
    },
  },

  // 3. Deep Conditioning Treatment
  {
    id: 3,
    name: "Nourishing Conditioner",
    description: "Rinse out conditioner for all hair types",
    price: 40.0,
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741945966/IMG_9629_httwh5.jpg",
    category: "Treatments",
    featured: true,
    images: productImages.treatment,
    details: {
      usage:
        "Apply generously to clean, damp hair. Leave for 15-30 minutes under a heating cap. Rinse thoroughly.",
      benefits: [
        "Intense moisture penetration",
        "Repairs damaged strands",
        "Improves hair manageability",
        "Reduces split ends",
      ],
      ingredients:
        "Aqua, Grapeseed Oil,Shea Butter, Rice Bran Oil, Cetearyl Alcohol,Hydrolized Wheat Protein, Nettle Extract, Horsetail Extract, Cetyl Alcohol, D Panthenol, Sodium PCA, Oats Extract, Stearalkonium Chloride, Saw Palmetto, Hydrolized Silk Protein, Fragrance Hydrolized Collagen Peptide, Germall Plus",
      whenToUse: [
        "Weekly as part of wash day routine",
        "After chemical treatments",
        "When hair feels dry or brittle",
        "Before protective styling",
      ],
      tips: "For maximum benefits, use with a heating cap,shower cap or steamer. Shouldn't be left in the hair for more than 1 hour for intense treatment.",
    },
  },

  // 4. Protein Treatment
  {
    id: 4,
    name: "Hydrating Shampoo",
    description: "Hydrating shampoo for all hair types",
    price: 40.0,
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741946380/IMG_9547_sdmx5k.jpg",
    category: "Treatments",
    featured: false,
    images: productImages.treatment,
    details: {
      usage: "Apply on wet hair, massage and rinse out.",
      benefits: [
        "Deep hydration for dry hair",
        "Reduces frizz and breakage",
        "Enhances natural curl pattern",
        "Promotes hair elasticity",
      ],
      ingredients:
        "Alpha clefin sulfonate, cocamidopropyl betaine. Coco glucoside. glycerine. Guar Methylsulfonymethane, Cocoa butter, Shea butter, Sodium laureth sulfate, Cor silk extract, Saw Palmetto,Citric acid, EDTA, Cermall plus, Fragrance.",
      whenToUse: [
        "After chemical treatments",
        "When hair feels weak or stretchy",
        "As part of monthly maintenance",
        "Before protective styling",
      ],
      tips: "Always follow with a Nourishing conditioner.",
    },
  },

  // 5. Liquid Gold (Large)
  {
    id: 5,
    name: "Liquid Gold (Large)",
    description: "Natural oil blend for hair growth and scalp health",
    price: 110.0,
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741946292/IMG_9563_b7ttqx.jpg",
    category: "Oils",
    featured: false,
    images: productImages.oil,
    details: {
      usage:
        "Massage into scalp and distribute through hair. Use 2-3 times per week..",
      benefits: [
        "Stimulates hair growth",
        "Nourishes scalp",
        "Strengthens hair follicles",
        "Prevents breakage",
      ],
      ingredients:
        "Castor Oil, Sunflower Oil, Fenugreek, Lavender Essential Oil, Amla Powder, Vitamin E",
      whenToUse: [
        "During scalp massages",
        "Before washing hair (pre-poo)",
        "Before bed for overnight treatment",
        "As a sealant after moisturizing",
      ],
      tips: "Warm the oil slightly before application for better absorption. Perfect for hot oil treatments.",
    },
  },

  // 6. Hydrating Mist
  {
    id: 6,
    name: "Hydrating Leave-In Mist",
    description: "Hydrating leave-in mist for all hair types",
    price: 50.0,
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741946217/IMG_9580_dwtryb.jpg",
    category: "Treatments",
    featured: false,
    images: productImages.treatment,
    details: {
      usage:
        "Apply on damp or dry hair to infuse moisture. Spray on hair and massage in.Suitable for use in braids and mid wash days & on dry hair. It's a leave on product",
      benefits: [
        "Hydrates and moisturizes hair",
        "Creates more luster and shine",
        "Leaves hair feeling soft and manageable",
        "Helps prevent dryness and breakage",
      ],
      ingredients:
        "Distilled water, Milk extract,Vitamin b3, Mushroom extract,Fragrance,Preservative",
      whenToUse: [
        "In between washes",
        "When hair feels dry or brittle",
        "Before protective styling",
        "As part of weekly hair maintenance",
      ],
      tips: "Always follow with a growth oil.",
    },
  },

  // === Product Bundles ===
  // 7. Essential Duo Bundle
  {
    id: 7,
    name: "Hydration & Nourishing Duo",
    description: "Complete cleansing and conditioning duo for healthy hair",
    price: 80.0,
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741945989/IMG_9623_koglsj.jpg",
    category: "Bundles",
    featured: true,
    details: {
      includes: ["Hydrating Shampoo", "Nourishing Conditioner"],
      usage: "Use as part of your regular wash day routine",
      benefits: [
        "Complete cleansing and conditioning system",
        "Saves money compared to individual purchases",
        "Perfectly paired products",
        "Maintains hair health",
      ],
      value: "Save 15% compared to buying separately",
    },
  },

  // 8. Growth & Moisture Duo
  {
    id: 8,
    name: "Growth & Moisture Duo",
    description: "Perfect combination for hair growth and moisture retention",
    price: 115.0,
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741946087/IMG_9619_mrxbxp.jpg",
    category: "Bundles",
    featured: true,
    details: {
      includes: ["Liquid Gold", "Chebe Butter"],
      usage: "Use as part of your moisturizing and growth routine",
      benefits: [
        "Promotes hair growth",
        "Maximum moisture retention",
        "Perfect combination for length retention",
        "Enhanced hair health",
      ],
      value: "Save 15% compared to buying separately",
    },
  },

  // 9. Ultimate Moisture Bundle
  {
    id: 9,
    name: "LOC & Growth Bundle",
    description: "Complete moisture system for ultimate hydration",
    price: 165.0,
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1743031364/loc_uqk0zw.jpg",
    category: "Bundles",
    featured: true,
    details: {
      includes: ["Chebe Butter", "Liquid Gold", "Hydrating Leave-In Mist"],
      usage: "Use as part of your daily and weekly moisture routine",
      benefits: [
        "Complete moisture system",
        "Maximum hydration",
        "Versatile product combination",
        "Perfect for all hair types",
      ],
      value: "Save 20% compared to buying separately",
    },
  },

  // 10. Premium Hair Care Bundle
  {
    id: 10,
    name: "Premium Hair Care Bundle",
    description: "Complete hair care system for optimal hair health",
    price: 240.0,
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741946126/IMG_9604_mckypx.jpg",
    category: "Bundles",
    featured: false,
    details: {
      includes: [
        "Hydrating Shampoo",
        "Nourishing Conditioner",
        "Chebe Butter",
        "Liquid Gold",
        "Moisture Lock",
      ],
      usage: "Complete hair care routine from wash day to daily styling",
      benefits: [
        "Full hair care system",
        "Perfectly paired products",
        "Maximum results",
        "Great value",
      ],
      value: "Save 25% compared to buying separately",
    },
  },

  // 11. Luxury Complete Collection
  {
    id: 11,
    name: "Luxury Complete Collection",
    description: "The ultimate complete hair care collection",
    price: 285.0,
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741946157/IMG_9603_q20ujf.jpg",
    category: "Bundles",
    featured: false,
    details: {
      includes: [
        "Hydrating Shampoo",
        "Nourishing Conditioner",
        "Chebe Butter",
        "Liquid Gold",
        "Hydrating Leave-In Mist",
        "Moisture Lock",
      ],
      usage: "Complete hair care system for maximum results",
      benefits: [
        "Comprehensive hair care routine",
        "Maximum savings",
        "Perfect for all hair types",
        "Everything needed for optimal hair health",
      ],
      value: "Save 30% compared to buying separately",
    },
  },

  // Accessories Category Products
  {
    id: 13,
    name: "Microfibre Hair Towel",
    description:
      "Ultra-absorbent microfibre towel specially designed for natural hair. Reduces frizz and drying time.",
    price: 25.0,
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1742824951/towel_4_chicmd.jpg",
    category: "Accessories",
    featured: false,
    images: productImages.accessories,
    details: {
      usage: "Use after washing hair to gently remove excess water",
      benefits: [
        "Ultra-absorbent material",
        "Reduces drying time",
        "Minimizes frizz and breakage",
        "Gentle on all hair types",
      ],
      ingredients: "Premium microfibre material",
      whenToUse: [
        "After washing hair",
        "During deep conditioning treatments",
        "For gentle drying",
        "As part of your wash day routine",
      ],
      tips: "Machine washable, tumble dry on low heat.",
    },
  },
  {
    id: 14,
    name: "Bamboo Wide Tooth Comb",
    description:
      "Gentle detangling comb made from sustainable bamboo. Perfect for wet or dry hair.",
    price: 15.0,
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1742824986/wide_tooth_comb_me636j.jpg",
    category: "Accessories",
    featured: true,
    images: productImages.accessories,
    details: {
      usage: "Use for gentle detangling on wet or dry hair",
      benefits: [
        "Made from sustainable bamboo",
        "Wide teeth for easy detangling",
        "Reduces breakage and split ends",
        "Anti-static properties",
      ],
      ingredients: "100% sustainable bamboo",
      whenToUse: [
        "During detangling sessions",
        "On wet or dry hair",
        "For gentle styling",
        "During deep conditioning",
      ],
      tips: "Clean with mild soap and water, air dry completely.",
    },
  },
  {
    id: 15,
    name: "Bamboo Afro Comb",
    description:
      "Traditional afro comb made from eco-friendly bamboo. Perfect for styling and detangling thick hair.",
    price: 12.0,
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1742823755/afro_comb_dbfuij.jpg",
    category: "Accessories",
    featured: false,
    images: productImages.accessories,
    details: {
      usage: "Use for styling and detangling thick, coily hair",
      benefits: [
        "Eco-friendly bamboo construction",
        "Perfect for picking and styling afro hair",
        "Sturdy teeth for thorough detangling",
        "Comfortable grip handle",
      ],
      ingredients: "100% sustainable bamboo",
      whenToUse: [
        "For styling afro hair",
        "During detangling sessions",
        "For volume and shape",
        "Daily maintenance",
      ],
      tips: "Clean with mild soap and water after each use, air dry completely.",
    },
  },
  {
    id: 16,
    name: "Luxury Shower Cap",
    description:
      "Water-resistant shower cap with adjustable fit. Protects hair styles during showering.",
    price: 5.0,
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1743593369/shower-cap_dmegun.jpg",
    category: "Accessories",
    featured: false,
    images: productImages.accessories,
    details: {
      usage: "Wear while showering to protect hairstyles",
      benefits: [
        "Water-resistant material",
        "Adjustable fit for all hair volumes",
        "Extra-large size for protective styles",
        "Comfortable elastic band",
      ],
      ingredients: "Premium water-resistant material",
      whenToUse: [
        "During showering",
        "While swimming",
        "To protect hairstyles",
        "During spa treatments",
      ],
      tips: "Rinse after use and hang to dry.",
    },
  },
  {
    id: 17,
    name: "Chebe Hair Butter (Large)",
    description:
      "Rich, nourishing hair butter infused with natural ingredients for maximum moisture retention and hair growth",
    price: 140.0,
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1742824206/butter_angle2_o9idsj.jpg",
    category: "Moisturizers",
    featured: false,
    images: productImages.moisturizer,
    details: {
      usage:
        "Apply to damp or dry hair. A little goes a long way. Can be used for twisting, braiding, or as a daily moisturizer.",
      benefits: [
        "Deep moisture penetration",
        "Promotes length retention",
        "Reduces breakage",
        "Enhances natural hair texture",
      ],
      ingredients:
        "Shea butter, Jamaican black castor oil, Rice bran oil, Vitamin E oil",
      whenToUse: [
        "Daily moisture maintenance",
        "Before protective styling",
        "For twist-outs and braid-outs",
        "As a sealant after moisturizing",
      ],
      tips: "Warm a small amount between palms before applying. Best used on damp hair for maximum absorption.",
    },
  },
  {
    id: 18,
    name: "Chebe Hair Butter (Small)",
    description:
      "Rich, nourishing hair butter infused with natural ingredients for maximum moisture retention and hair growth",
    price: 55.0,
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1743593598/butter-small_elz8c3.jpg",
    category: "Moisturizers",
    featured: false,
    images: productImages.moisturizer,
    details: {
      usage:
        "Apply to damp or dry hair. A little goes a way. Can be used for twisting, braiding, or as a daily moisturizer.",
      benefits: [
        "Deep moisture penetration",
        "Promotes length retention",
        "Reduces breakage",
        "Enhances natural hair texture",
      ],
      ingredients:
        "Shea butter, Jamaican black castor oil, Rice bran oil, Vitamin E oil",
      whenToUse: [
        "Daily moisture maintenance",
        "Before protective styling",
        "For twist-outs and braid-outs",
        "As a sealant after moisturizing",
      ],
      tips: "Warm a small amount between palms before applying. Best used on damp hair for maximum absorption.",
    },
  },
];
